var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasVuex
        ? _c(
            "split-pane",
            [
              _vm.defer(3)
                ? _c("vuex-history", { attrs: { slot: "left" }, slot: "left" })
                : _vm._e(),
              _vm.defer(5)
                ? _c("vuex-state-inspector", {
                    attrs: { slot: "right" },
                    slot: "right"
                  })
                : _vm._e()
            ],
            1
          )
        : _c("div", { staticClass: "notice" }, [
            _c("div", [_vm._v("\n      No Vuex store detected.\n    ")])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }